import { render } from "./AddCenter.vue?vue&type=template&id=32adfe0e&scoped=true"
import script from "./AddCenter.vue?vue&type=script&lang=js"
export * from "./AddCenter.vue?vue&type=script&lang=js"

import "./AddCenter.vue?vue&type=style&index=0&id=32adfe0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32adfe0e"]])

export default __exports__